<p-dialog
    [(visible)]="visible"
    (onHide)="closeModal()"
    [modal]="true"
    [style]="{ width: '75vw', maxWidth: '900px', height: '90vh' }"
    [responsive]="true"
    [breakpoints]="{ '641px': '100vw' }"
    [contentStyle]="{ 'overflow-y': 'auto', padding: '1rem' }"
    [baseZIndex]="10000"
>
    <p-header>
        <span class="fw-bold">{{ 'home.widgetConnect.details' | translate }}</span>
    </p-header>

    <div *ngIf="profile" class="container-fluid">
        <div class="d-flex align-items-left card box-shadow p-3">
            <div class="row p-3 align-items-center">
                <div class="d-flex align-items-center col">
                    <app-user-avatar
                        [firstName]="profile.firstName"
                        [lastName]="profile.lastName"
                        [picture]="profile.profilePicture"
                        class="mr-3"
                    ></app-user-avatar>
                    <div class="d-flex flex-column">
                        <span class="fw-bold">{{ profile.firstName }} {{ profile.lastName }}</span>
                        <div>&#8226; <app-contact-modal [user]="profile"></app-contact-modal></div>
                    </div>
                </div>
                <div class="col-auto ms-auto">
                    <app-private-conversation-button
                        isRounded
                        [user]="profile"
                    ></app-private-conversation-button>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                    <div class="h-100">
                        <div class="card-body">
                            <h5 class="common-gray">{{ 'directory.pages.userProfile.myCommunities' | translate }}</h5>
                            <app-user-communities [communities]="profile.communities"></app-user-communities>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                    <div class="h-100">
                        <div class="card-body">
                            <h5 class="common-gray">{{ 'directory.pages.userProfile.organizationTitle' | translate }}</h5>

                            <div [routerLink]="['/organizations/', profile.organization?.id]" class="d-flex align-items-center mb-2">
                                <em class="icon icon-organization fw-b mr-2"></em>
                                <span class="text-link" *ngIf="profile.organization?.id; else noData">{{ profile.organization?.name }}</span>
                            </div>

                            <div class="d-flex align-items-center mb-2">
                                <em class="icon icon-marker fw-b mr-2"></em>
                                <span class="common-gray" *ngIf="organization?.city && organization?.city !== 'undefined'; else noData">{{
                                    organization?.city
                                }}</span>
                            </div>

                            <div class="d-flex align-items-center">
                                <em class="icon icon-activity fw-b mr-2"></em>
                                <span
                                    class="common-gray"
                                    *ngIf="organization?.businessArea?.name && organization.businessArea.name !== notFilledInText; else noData"
                                    >{{ organization?.businessArea?.name | wtranslate : 'businessAreas' }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12 col-sm-6 mb-3">
                <div class="card box-shadow h-100">
                    <div class="card-body">
                        <h5 class="common-gray">{{ 'filters.shared.skillsFilters' | translate }}</h5>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item common-gray" *ngIf="(skills || [])?.length === 0; else elseBlockSkills">
                                {{ 'directory.pages.userProfile.noSkill' | translate }}
                            </li>
                            <ng-template #elseBlockSkills>
                                <li class="list-group-item common-gray" *ngFor="let skill of skills">
                                    {{ skill.displayName | wtranslate : 'skills' }}
                                </li>
                            </ng-template>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-6 mb-3">
                <div class="card box-shadow h-100">
                    <div class="card-body">
                        <h5 class="common-gray">{{ 'filters.shared.interestsCenterFilters' | translate }}</h5>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item common-gray" *ngIf="(interests || [])?.length === 0; else elseBlockInterests">
                                {{ 'directory.pages.userProfile.nointerest' | translate }}
                            </li>
                            <ng-template #elseBlockInterests>
                                <li class="list-group-item common-gray" *ngFor="let interest of interests">
                                    {{ interest.name | wtranslate : 'interests' }}
                                </li>
                            </ng-template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p-footer>
        <div class="d-flex p-0 justify-content-between align-items-center" style="width: 100%">
            <button
                pButton
                pRipple
                type="button"
                label="{{ 'home.widgetConnect.goToDirectory' | translate }} >"
                class="p-button-outlined"
                style="color: var(--primary-color); border-color: var(--primary-color)"
                tooltipPosition="top"
                (click)="goToDirectory()"
            ></button>

            <button
                pButton
                pRipple
                type="button"
                label="{{ 'home.widgetConnect.close' | translate }}"
                class="button-refresh"
                pTooltip="Fermer"
                tooltipPosition="top"
                (click)="closeModal()"
            ></button>
        </div>
    </p-footer>
</p-dialog>
